import * as React from 'react';
import {Target} from 'lucide-react';
import ResourceFigure from './ResourceFigure';

export default function LeadResourceFigure({className}) {
	return (
		<ResourceFigure
			icon={Target}
			bgClassName="bg-blue-50 border-blue-200"
			iconClassName="text-blue-500"
			className={className}
		/>
	);
}
